import React, {Component} from 'react';
import {
    List,
    TextField,
    Filter,
    downloadCSV,
    AutocompleteArrayInput, SearchInput, NumberInput
} from 'react-admin';
import {parse} from 'json2csv';
import {IirsaCountriesService} from '~config/services/iirsa_countries.service';

import CustomDatagrid from '../components/CustomDatagrid';

import i18next from "i18next";

import ListPageLayout from "../components/ListPageLayout";
import {RA_LIST_CUSTOM_STYLE} from "~screens/Dashboard/screens/ProjectsIIRSA/constants";
import {useSyncStoreToLocation} from "../hooks/useSyncStoreToLocation";

class RouteFilter extends Component {
    state = {
        countries: []
    };

    constructor() {
        super({});
        const cs = new IirsaCountriesService();
        cs.get_la().then(r => this.setState({countries: r.data}));
    }

    render() {
        return (
            <Filter {...this.props}>
                <SearchInput source={'search'} alwaysOn variant={'outlined'}/>

                <AutocompleteArrayInput
                    label={i18next.t('projects-iirsa:countries')}
                    source="countries"
                    choices={this.state.countries}
                    variant={'outlined'}
                />

                <NumberInput label={i18next.t('projects-iirsa:projectsMin')} source={'cantidad_acciones_min'} variant={'outlined'}/>
                <NumberInput label={i18next.t('projects-iirsa:projectsMax')} source={'cantidad_acciones_max'} variant={'outlined'}/>
            </Filter>
        );
    }
}

const formatRoute = r => {
    r[i18next.t('projects-iirsa:name')] = r.name;
    r[i18next.t('projects-iirsa:description')] = r.description;
    r[i18next.t('projects-iirsa:countries')] = r.countriesFormatted;
    r[i18next.t('projects-iirsa:projects')] = r.actions;
}

const exporter = proj => {
    const page = proj?.page || proj || [];
    page.forEach(p => {
        formatRoute(p);
    });
    const fields = [
        i18next.t('projects-iirsa:name'),
        i18next.t('projects-iirsa:description'),
        i18next.t('projects-iirsa:countries'),
        i18next.t('projects-iirsa:projects'),
    ];
    const formattedCsv = parse(proj, {fields});
    downloadCSV(formattedCsv, i18next.t('projects-iirsa:territories'));
};

// eslint-disable-next-line react/no-multi-comp
function RoutesList(props) {
    useSyncStoreToLocation({
        storeKey: 'territories.listParams',
        sort: {field: 'id', order: 'ASC'},
        perPage: 50,
    });

    return (<ListPageLayout mapPath={'/territories/map'} title={i18next.t('projects-iirsa:territories')}>
        <List
            {...props}
            bulkActionButtons={false}
            exporter={exporter}
            filters={<RouteFilter />}
            perPage={50}
            syncWithLocation={true}
            storeKey='territories.listParams'
            disableSyncWithLocation={false}
            sx={RA_LIST_CUSTOM_STYLE}
        >
            <CustomDatagrid rowClick="show" bulkActionButtons={false} >
                <TextField source="name" label={i18next.t('projects-iirsa:name')} sortBy={'nombre'}/>
                <TextField source="countriesFormatted" label={i18next.t('projects-iirsa:countries')} sortBy={'paises_string'}/>
                <TextField source="actions" label={i18next.t('projects-iirsa:projects')} sortBy={'cantidad_acciones'} textAlign={'center'} />
            </CustomDatagrid>
        </List>
    </ListPageLayout>);
}

export default RoutesList;
